module.exports = __webpack_public_path__ + "static/media/icon-close.defe8474.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-close.svg
// module id = 1610
// module chunks = 0